<!--
 * @Author: 熊燕萍
 * @Date: 2022-01-18 14:40:22
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-04-27 19:03:01
 * @Description: 列表公用组件
 * @FilePath: \ys.gnss\src\components\common\YsTableList.vue
-->
<template>
  <div style="height: 100%">
    <!-- 列表 -->
    <div
      ref="table"
      class="ys-table"
      :style="{ height: showPagination ? 'calc(100% - 40px)' : '100%' }"
      style="overflow: auto"
    >
      <!-- 嵌套树 -->
      <el-table
        :row-key="table.rowKey"
        :default-expand-all="table.cospanIs"
        :tree-props="table.treeProps"
        v-if="table.tabletree"
        ref="el-table"
        :height="table['max-height'] ? '' : '100%'"
        :max-height="table['max-height'] || ''"
        v-loading="table.loading"
        :data="table.list"
        :stripe="stripeVisible"
        :border="borderVisible"
        :load="table.load"
        :lazy="table.lazy"
        :highlight-current-row="table['highlight-current-row']"
        :show-summary="showSummary"
        :cell-style="cellStyle"
        :expand-row-keys="table.expandRowKeys"
        :header-cell-class-name="headerClassName"
        :tooltip-effect="tooltips"
        :indent="table.indents"
      >
        <!-- 开启树形多选 -->
        <el-table-column
          v-if="table.showtreeSelection"
          width="120"
          align="left"
        >
          <template #header>
            <el-checkbox
              v-model="selectAll"
              :checked="selectAll"
              :indeterminate="isIndeterminate"
              @change="setCheckAll"
            />
            {{ table.selectionName }}
          </template>

          <template #default="scope">
            <el-checkbox
              v-model="scope.row[selectionConfig.checked]"
              :checked="scope.row[selectionConfig.checked]"
              :indeterminate="scope.row[selectionConfig.indeterminate]"
              :disabled="scope.row[selectionConfig.disabled]"
              @change="setCheck(scope.row)"
            />
          </template>
        </el-table-column>

        <!-- 遍历列 -->
        <template v-for="column in table.columns">
          <el-table-column
            v-if="!column.hide"
            :key="column.label"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :align="column.align"
            :header-align="column.headerAlign"
            :sortable="column.sortable"
            :show-overflow-tooltip="column.showNoOverflowTooltip ? false : true"
            :fixed="column.fixed"
            :header-class-name="headerClassName"
          >
            <template slot-scope="scope">
              <!-- 带操作按钮 -->
              <template v-if="column.operation">
                <template v-for="(btn, index) in column.operation">
                  <el-link
                    :key="index"
                    :class="btn.class"
                    :type="btn.type"
                    :icon="btn.icon"
                    v-if="
                      btn.eleType == 'el-link' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :style="btn.style"
                    @click="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                    {{ btn.btnName }}
                  </el-link>
                  <el-tag
                    :key="index"
                    :type="btn.type"
                    :icon="btn.icon"
                    size="small"
                    v-else-if="
                      btn.eleType == 'el-tag' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :style="btn.style"
                    :effect="btn.tagEffect"
                    @click="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                    {{ btn.btnName }}
                  </el-tag>
                  <el-dropdown
                    :key="index"
                    :type="btn.type"
                    :icon="btn.icon"
                    size="small"
                    v-else-if="
                      btn.eleType == 'el-dropdown' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :style="btn.style"
                    :effect="btn.tagEffect"
                  >
                    <span class="el-dropdown-link">
                      {{ btn.btnName }}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="
                          typeof btn.clickFun === 'function' &&
                            btn.clickFun(drop, scope.row)
                        "
                        v-for="(drop, dropIndex) in btn.dropList"
                        :key="dropIndex"
                        >{{ drop }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-switch
                    v-else-if="
                      btn.eleType == 'el-switch' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :key="index"
                    :value="scope.row[column.prop]"
                    active-color="#11559f"
                    inactive-color="#ecf5ff"
                    @change="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                  </el-switch>
                  <el-button
                    :key="index"
                    :type="btn.type"
                    size="mini"
                    plain
                    :icon="btn.icon"
                    v-else-if="
                      !btn.vIf ||
                      (typeof btn.vIf === 'function' && btn.vIf(scope.row))
                    "
                    :style="btn.style"
                    @click.stop="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                    {{ btn.btnName }}
                  </el-button>
                </template>
              </template>
              <!-- 带数据格式化 -->
              <span
                v-else-if="column.formatData"
                v-html="column.formatData(scope.row, column.prop)"
                @click="column.formatDataClickFun(scope.row)"
              ></span>
              <!-- 纯数据展示 -->
              <template v-else>
                <span
                  :style="[column.style]"
                  @click="
                    typeof column.styleClickFun === 'function' &&
                      column.styleClickFun(scope.row)
                  "
                  >{{ deepGet(scope.row, column.prop) }}
                </span>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-table
        v-else
        ref="el-table"
        :height="table['max-height'] ? null : '100%'"
        :max-height="table['max-height'] || null"
        v-loading="table.loading"
        :data="table.list"
        :stripe="stripeVisible"
        :border="borderVisible"
        :row-key="table.rowKey"
        :tree-props="table.treeProps"
        :load="table.load"
        :lazy="table.lazy"
        :highlight-current-row="table['highlight-current-row']"
        :show-summary="showSummary"
        @sort-change="sortChange"
        @row-click="rowClick"
        @selection-change="handleSelectionChange"
        @select="selectRow"
        :span-method="handleMergeRow"
        :cell-style="cellStyle"
        :expand-row-keys="table.expandRowKeys"
        :header-cell-class-name="headerClassName"
        :tooltip-effect="tooltips"
      >
        <el-table-column
          type="selection"
          width="55"
          v-if="showSelection"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="70"
          v-if="showIndex"
          :fixed="table.indexFixed"
        >
          <template #default="scope">
            <template v-if="showPagination"
              ><span class="num_table">{{
                (pagination.pageNum - 1) * pagination.pageSize +
                (scope.$index + 1)
              }}</span>
            </template>
            <template v-else
              ><span class="num_table">{{ scope.$index + 1 }}</span></template
            >
          </template>
        </el-table-column>
        <template v-for="column in table.columns">
          <el-table-column
            v-if="!column.hide"
            :key="column.label"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :align="column.align"
            :header-align="column.headerAlign"
            :sortable="column.sortable"
            :show-overflow-tooltip="column.showNoOverflowTooltip ? false : true"
            :fixed="column.fixed"
            :header-class-name="headerClassName"
          >
            <template slot-scope="scope">
              <!-- 带操作按钮 -->
              <template v-if="column.operation">
                <template v-for="(btn, index) in column.operation">
                  <el-link
                    :key="index"
                    :class="btn.class"
                    :type="btn.type"
                    :icon="btn.icon"
                    v-if="
                      btn.eleType == 'el-link' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :style="btn.style"
                    @click="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                    {{ btn.btnName }}
                  </el-link>
                  <el-tag
                    :key="index"
                    :type="btn.type"
                    :icon="btn.icon"
                    size="small"
                    v-else-if="
                      btn.eleType == 'el-tag' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :style="btn.style"
                    :effect="btn.tagEffect"
                    @click="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                    {{ btn.btnName }}
                  </el-tag>
                  <el-dropdown
                    :key="index"
                    :type="btn.type"
                    :icon="btn.icon"
                    size="small"
                    v-else-if="
                      btn.eleType == 'el-dropdown' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :style="btn.style"
                    :effect="btn.tagEffect"
                  >
                    <span class="el-dropdown-link">
                      {{ btn.btnName }}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="
                          typeof btn.clickFun === 'function' &&
                            btn.clickFun(drop, scope.row)
                        "
                        v-for="(drop, dropIndex) in btn.dropList"
                        :key="dropIndex"
                        >{{ drop }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-switch
                    v-else-if="
                      btn.eleType == 'el-switch' &&
                      (!btn.vIf ||
                        (typeof btn.vIf === 'function' && btn.vIf(scope.row)))
                    "
                    :key="index"
                    :value="scope.row[column.prop]"
                    active-color="#11559f"
                    inactive-color="#ecf5ff"
                    @change="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                  </el-switch>
                  <el-button
                    :key="index"
                    :type="btn.type"
                    size="mini"
                    plain
                    :icon="btn.icon"
                    v-else-if="
                      !btn.vIf ||
                      (typeof btn.vIf === 'function' && btn.vIf(scope.row))
                    "
                    :style="btn.style"
                    @click.stop="
                      typeof btn.clickFun === 'function' &&
                        btn.clickFun(scope.row)
                    "
                  >
                    {{ btn.btnName }}
                  </el-button>
                </template>
              </template>

              <!-- 带数据格式化 -->
              <span
                v-else-if="column.formatData"
                v-html="column.formatData(scope.row, column.prop)"
                @click="column.formatDataClickFun(scope.row)"
              ></span>
              <!-- 纯数据展示 -->
              <template v-else>
                <span
                  :style="[column.style]"
                  @click="
                    typeof column.styleClickFun === 'function' &&
                      column.styleClickFun(scope.row)
                  "
                  >{{ deepGet(scope.row, column.prop) }}
                </span>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      v-if="showPagination"
      background
      :current-page.sync="pagination.pageNum"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      @current-change="initData"
      style="margin-top: 4px"
      layout="->, total,prev, pager, next "
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "YsTableList",
  props: {
    //列表相关配置参数,对象中必须包含以下四个参数
    //{columns:[],list:[],loading:false,total:0 }
    //嵌套树列表独有相关配置参数
    //{cospanIs:true,indents:30,tabletree:true,showtreeSelection:true,selectionName:'全选'}
    table: Object,
    //是否显示分页，默认显示
    showPagination: {
      type: Boolean,
      default: true,
    },
    //是否显示序号列
    showIndex: {
      type: Boolean,
      default: true,
    },
    //是否显示多选框
    showSelection: {
      type: Boolean,
      default: false,
    },
    //是否显示合计行
    showSummary: {
      type: Boolean,
      default: false,
    },
    cellStyle: {
      type: Function,
      default: function () {},
    },
    colorVisible: {
      type: Boolean,
      default: false,
    },
    //是否合并第一行
    isMergeRow: {
      type: Boolean,
      default: false,
    },
    borderVisible: {
      type: Boolean,
      default: false,
    },
    stripeVisible: {
      type: Boolean,
      default: false,
    },
    tooltips: {
      type: String,
      default: "dark",
    },
    //是否设置单选
    singleSelect: {
      type: Boolean,
      default: false,
    },

    //嵌套树多选框配置
    selectionConfig: {
      type: Object,
      default: () => ({
        checked: "checked", //选中
        indeterminate: "indeterminate", //半选
        disabled: "disabled", //禁用
      }),
    },
    rowHeight: {
      type: Number,
      default: 37,
    },
  },
  data() {
    return {
      selectedRow: {}, //单选
      //分页参数
      pagination: {
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      sort: {
        orderBy: null,
        orderByWay: null,
      },
      timer: null,
      //表格嵌套树
      selectAll: false, // 全选
      isIndeterminate: false, // 半选
    };
  },
  watch: {
    "table.total"(val) {
      this.pagination.total = val;
    },
  },
  methods: {
    /**
     * @desc:
     * @param {*} columnIndex
     * @return {*}动态设置头部样式
     */
    headerClassName({ columnIndex }) {
      //如果有序号或者选中下标需要相对应减少
      const index =
        this.showIndex && this.showSelection
          ? columnIndex - 2
          : !this.showIndex ||
            this.showSelection ||
            this.showIndex ||
            !this.showSelection
          ? columnIndex - 1
          : columnIndex;
      //只加载除了序号和选中以外的数据
      const columns = index >= 0 ? this.table.columns[index] : {};
      return columns.headerClassName || "";
    },
    /**
     * @description: 行点击事件
     * @param {*} row
     * @return {*}
     */
    rowClick(row) {
      this.$emit("rowClick", row);
    },
    formatDataClickFun(row) {
      this.$emit("formatDataClickFun", row);
    },
    /**
     * @desc: 页数切换更新列表数据
     * @param {*} pageSize
     * @return {*}
     */
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNum = 1; //重置页数
      this.$emit("updateTableData");
    },
    /**
     * @description: 翻页更新列表数据
     * @param {*} pageNum
     * @return {*}
     */
    initData(pageNum = 1) {
      this.pagination.pageNum = pageNum;
      this.$emit("updateTableData");
    },
    /**
     * @description: 在对象中取值
     * @param {*} obj 要检索的对象
     * @param {*} keys 要获取属性的路径
     * @return {*}
     */
    deepGet(obj, keys) {
      if (!keys) return "";
      return (
        !Array.isArray(keys)
          ? keys.replace(/\[/g, ".").replace(/\]/g, "").split(".")
          : keys
      ).reduce((o, k) => (o || {})[k], obj);
    },
    /**
     * @description: 列表pageSize计算
     * @param {*}
     * @return {*}
     */
    getPageSize() {
      if (this.$refs.table.offsetHeight) {
        let height = this.$refs.table.offsetHeight; //得到列表div的高度
        this.pagination.pageSize = Math.floor((height - 40) / 37); //计算列表行数
      } else {
        this.$nextTick(() => {
          let height = this.$refs.table.offsetHeight; //得到列表div的高度
          this.pagination.pageSize = Math.floor((height - 40) / 37); //计算列表行数
        });
      }
    },
    /**
     * @description: 排序变更
     * @param {*} evt 排序变更事件，返回column属性，prop属性名，order降序或升序
     * @return {*}
     */
    sortChange(evt) {
      this.sort.orderBy = evt.prop;
      switch (evt.order) {
        case "descending":
          this.sort.orderByWay = "desc";
          break;
        case "ascending":
          this.sort.orderByWay = "asc";
          break;
        default:
          this.sort.orderByWay = null;
          this.sort.orderBy = null;
          break;
      }
      this.initData();
    },
    /**
     * @description: 合并行
     * @return {*}
     */
    handleMergeRow({ rowIndex, columnIndex }) {
      if (this.isMergeRow) {
        if (columnIndex === 0) {
          // 格式化table数据
          const _row = this.flitterData(this.table.list).one[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    flitterData(arr) {
      let spanOneArr = [];
      let concatOne = 0;
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
        } else {
          //fxlx 修改
          if (item.fxlx === arr[index - 1].fxlx) {
            //第一列需合并相同内容的判断条件
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
      };
    },
    /**
     * @description: 多选
     * @param {*} evt
     * @return {*}
     */
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    /**
     * @description: 单选
     * @return {*}
     * @author:
     */
    selectRow(selection, val) {
      console.log(selection, val);
      if (!this.singleSelect) return false;
      // 接收两个参数，selection为所有选中数据的集合，val为当前选择的数据
      // 先将所有选中的数据变为未选中状态
      this.$refs["el-table"].clearSelection();
      // // 如果选择完当前数据后selection为空数组，说明现在是取消勾选，无选中数据
      if (selection.length == 0) {
        this.selectedRow = []; // 清空data中绑定的selectedRow
        return;
      }
      // // 切换最近一次选择数据的状态
      this.$refs["el-table"].toggleRowSelection(val, true);
      // // 更新data中的selectedRow
      this.selectedRow = val;
      this.$emit("selectedRow", this.selectedRow);
    },

    //-----树节点嵌套-----//
    /**
     * @description:全选
     * @return {*}
     */
    setCheckAll() {
      this.table.list.forEach((item) => {
        if (!item[this.selectionConfig.disabled]) {
          item[this.selectionConfig.checked] = this.selectAll;
        }
        this.setChildren(item, this.selectAll);
      });
      this.isIndeterminate = false;
      this.getCheckedNodes(this.table.list);
    },
    /**
     * @description: 单选(表格树)
     * @param {*} row
     * @return {*}
     */
    setCheck(row) {
      // 设置该单元格所有子节点状态
      this.setChildren(row, row[this.selectionConfig.checked]);
      let result = this.setParentCheck(row);
      // 遍历到顶级，顶级无父节点，判断顶级节点是否都为选中
      if (!result) {
        let isAll = this.table.list.every((item) => {
          return item[this.selectionConfig.checked];
        });
        this.selectAll = isAll;

        if (isAll) {
          this.isIndeterminate = false;
        } else {
          let isIndeterminate = this.table.list.some((item) => {
            return (
              item[this.selectionConfig.checked] ||
              item[this.selectionConfig.indeterminate]
            );
          });
          this.isIndeterminate = isIndeterminate;
        }
      }
      this.getCheckedNodes(this.table.list);
    },
    /**
     * @description: 设置子节点
     * @param {*} row
     * @param {*} checked
     * @return {*}
     */
    setChildren(row, checked) {
      row[this.selectionConfig.indeterminate] = false;

      if (row[this.table.treeProps.children]) {
        row[this.table.treeProps.children].forEach((item) => {
          if (!item[this.selectionConfig.disabled]) {
            item[this.selectionConfig.checked] = checked;
            item[this.selectionConfig.indeterminate] = false;
          }
          if (row[this.table.treeProps.children]) {
            this.setChildren(item, checked);
          }
        });
      }
    },
    /**
     * @description:设置父节点
     * @param {*} row
     * @return {*}
     */
    setParentCheck(row) {
      // 寻找该行数据的父节点
      let parent = null;
      for (let i = 0; i < this.table.list.length; i++) {
        parent = this.findItem(this.table.list[i], row.parentId);
        if (parent != null) {
          break;
        }
      }
      // 遍历该行的父节点下，所有的子节点
      if (parent != null) {
        if (parent[this.table.treeProps.children]) {
          // 子节点是否全都选中，如果是则则勾选该节点
          let isAll = parent[this.table.treeProps.children].every((item) => {
            return item[this.selectionConfig.checked];
          });
          parent[this.selectionConfig.checked] = isAll;
          if (isAll) {
            parent[this.selectionConfig.indeterminate] = false;
          } else {
            let isIndeterminate = parent[this.table.treeProps.children].some(
              (item) => {
                return item[this.selectionConfig.checked];
              }
            );
            parent[this.selectionConfig.indeterminate] = isIndeterminate;
          }

          // 递归查找该行父级的父级节点
          this.setParentCheck(parent, parent[this.selectionConfig.checked]);
        }
      } else {
        // 遍历到顶级，停止
        return null;
      }
    },
    /**
     * @description:查递归找该行的父节点
     * @param {*} row
     * @param {*} id
     * @return {*}
     */
    findItem(row, id) {
      if (row[this.table.rowKey] == id) {
        return row;
      }
      if (row[this.table.treeProps.children]) {
        let parent = null;
        for (let i = 0; i < row[this.table.treeProps.children].length; i++) {
          parent = this.findItem(row[this.table.treeProps.children][i], id);
          if (parent) {
            break;
          }
        }
        return parent;
      } else {
        return null;
      }
    },
    /**
     * @description: 获取勾选节点
     * @return {*}
     */
    getCheckedNodes(data) {
      let checkedNodes = [];
      function traverse(nodes) {
        for (let node of nodes) {
          if (node.checked) {
            checkedNodes.push({ ...node }); // 使用 {...node} 来创建节点的浅拷
          }
          if (node.children && node.children.length > 0) {
            traverse(node.children);
          }
        }
      }

      traverse(data);
      // return checkedNodes;
      //将表格嵌套树选中节点数据返出
      this.$emit("handleSelectionChange", checkedNodes);
    },
  },

  mounted() {
    this.getPageSize();
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-table) {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .caret-wrapper {
    width: 12px;
  }

  .sort-caret {
    left: 3px;
  }

  .radius {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 3px;
  }

  .el-link {
    margin: 0px 5px;
  }

  .red-radius {
    background: #f56c6c;
  }

  .orange-radius {
    background: orange;
  }

  .yellow-radius {
    background: yellow;
  }

  .blue-radius {
    background: #168fff;
  }

  .el-link--success,
  .el-link--primary,
  .el-link--warning,
  .el-link--danger {
    color: #11559f !important;
  }

  .red-header {
    background-color: #ff6160 !important;
  }

  .orange-header {
    background-color: #fdd870 !important;
  }

  .yellow-header {
    background-color: #fffbbc !important;
  }

  .blue-header {
    background-color: #d8f2ff !important;
  }
}
</style>
